import Layout from '../../components/layout/Layout';
import Header from './components/Header';
import Filters from './components/Filters';
import { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import CardFilterDTO from '@src/adapters/dto/card/CardFilterDTO';
import { Grid } from '@mui/material';
import SearchResults from './components/results/SearchResults';
import CardPreviewDialog from '@src/components/card/card-preview-dialog/CardPreviewDialog';
import CardChangeRequestDTO from '@src/adapters/dto/card/CardChangeRequestDTO';
import useGetChangeRequests from '@src/adapters/hooks/card/useGetChangeRequests';

function ChangeRequests() {
  const { execute: find } = useGetChangeRequests();
  const [selectedCard, setSelectedCard] = useState<CardChangeRequestDTO>();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [cards, setCards] = useState<CardChangeRequestDTO[]>([]);
  const [recordCount, setRecordCount] = useState(0);

  const methods = useForm<CardFilterDTO>({
    mode: 'onChange',
    defaultValues: {
      currentPage: 0,
      pageSize: 10,
      sortAscending: false,
      sortKey: 'updated',
    },
  });

  const { control, setValue } = methods;

  const rawFilter = useWatch<CardFilterDTO>({
    control,
  });

  const filter = rawFilter as CardFilterDTO;

  const findCards = useCallback(() => {
    localStorage.setItem('changeRequestFilter', JSON.stringify(filter));

    find({ filter }).then((result) => {
      setCards(result.cards);
      if (result.recordCount !== undefined) {
        setRecordCount(result.recordCount);
      }
    });
  }, [filter, find]);

  useEffect(() => {
    findCards();
  }, [filter, findCards]);

  useEffect(() => {
    if (selectedCard) {
      setCards((prev) =>
        prev.map((c) => (c.id === selectedCard.id ? selectedCard : c))
      );
    }
  }, [selectedCard]);

  const handleCardSelected = (card: CardChangeRequestDTO) => {
    setSelectedCard(card);
    setPreviewOpen(true);
  };

  const handleSort = (key: string) => {
    if (filter.sortKey === key) {
      setValue('sortAscending', !filter.sortAscending);
    } else {
      setValue('sortKey', key);
      setValue('sortAscending', true);
    }
  };

  const handleCloseDialog = () => {
    setPreviewOpen(false);
    findCards();
  };

  return (
    <>
      <Layout>
        <FormProvider {...methods}>
          <Header />
          <Filters />
          <Grid container spacing={2}>
            <Grid item>
              <SearchResults
                cards={cards}
                filter={filter}
                recordCount={recordCount}
                onCardSelected={handleCardSelected}
                selectedCard={selectedCard}
                onSort={handleSort}
              />
            </Grid>
          </Grid>
        </FormProvider>
      </Layout>
      {selectedCard && (
        <CardPreviewDialog
          card={selectedCard}
          onClose={handleCloseDialog}
          open={previewOpen}
          showApprove={true}
        />
      )}
    </>
  );
}

export default ChangeRequests;
